<template>
  <div>
        <spinner  v-if="flagRuleIsLoading"></spinner>
        <div v-else class="block-content">

        <div v-if = "sharingTransmittedFlag" class="col-sm-12 col-md-12">
          <div class="col-sm-12 col-md-12 align-center">
            <i class="fa fa-check align-center fa-3x"></i>
          </div>
          <h3 class="font-w300 align-center push-10">{{textSharingTransmitted[actualLanguage]}}</h3>
          <h5 class="font-w300 align-center push-10">{{textSharingTransmitted2[actualLanguage]}}</h5>
          
          
          
        </div>
        <div v-else class="col-sm-12 col-md-12">
          <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
              <h2 class="font-w300 push-10 align-center"><i class="fa fa-share-alt fa-1x push-15-r "></i>{{overlayParameters.sharingReferenceName}}</h2>
  
              <h4 class="font-w300 push-10 align-center">{{overlayParameters.sharingGuessEmail}}</h4>

              <div v-if="displayUserOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-user push-5-r"></i>{{labelSectionUser[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.user" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.user[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

              <div v-if="displayGroupOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-users push-5-r"></i>{{labelSectionGroup[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.group" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.group[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

              <div v-if="displayBundleOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-usb push-5-r"></i>{{labelSectionBundle[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.bundle" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.bundle[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>


              <div v-if="displayDeviceOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-server push-5-r"></i>{{labelSectionDevice[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.device" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.device[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>


              <div v-if="displayChannelOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-television push-5-r"></i>{{labelSectionChannel[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.channel" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.channel[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

              <div v-if="displayAlertOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-bell push-5-r"></i>{{labelSectionAlert[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.alert" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.alert[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>

               <div v-if="displayCarOptions" class="form-group">
                <h5 class="font-w300 push-10"><i class="fa fa-car push-5-r"></i>{{labelSectionCar[actualLanguage]}}</h5>
                <div  v-for="(permission,index1) in ruleTemplate.permissions.car" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input type="checkbox" checked v-model="ruleTemplate.permissions.car[index1].value">
                      <span></span> {{permission.label[actualLanguage]}}
                  </label>
                </div>
              </div>             




              <div class="form-group">

                  <div class="col-sm-12 col-md-12">
                    <div>
                        <p><button @click="saveSharingPermissions()" type="button" class="btn btn-block btn-success" name="button">
                          <spinner size="small" v-if="commentIsSaving"></spinner>
                          <span v-else><i class="fa fa-share-alt fa-1x push-5-r "></i>{{labelButtonShare[actualLanguage]}}</span></button></p>
                    </div> 
                  </div>

              </div>
            </form>

          </div>
        </div>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from './Spinner.vue'
import _ from 'underscore'
export default {
  name: 'ConfigAccessRulesForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      flagRuleIsLoading : true,
      commentIsSaving: false,
      sharingTransmittedFlag:false,
      sharingEntityType:'ND',
      description : '',
      channelIndex : 0,
      workTime : 0,
      sharingReferenceName : '',
      sharingMessage : '',
      ruleTemplate : {},
      sharingUserRecipient : '',

      entityReferenceName:false,
      displayAlertOptions:false,
      displayChannelOptions:false,
      displayDeviceOptions:false,
      displayBundleOptions:false,
      displayGroupOptions:false,
      displayUserOptions:false,
      displayCarOptions:false,    


      actualLanguage : "FR",
      labelSectionUser: {FR: 'Accès usager', EN: 'User access'},
      labelSectionGroup: {FR: 'Group usagers', EN: 'User group'},
      labelSectionBundle: {FR: 'Groupes système', EN: 'Systems bundle'},
      labelSectionDevice: {FR: 'Appareil', EN: 'Device'},
      labelSectionChannel: {FR: 'Canaux de mesure', EN: 'Channels'},
      labelSectionAlert: {FR: 'Alerte', EN: 'Alerts'},
      labelSectionCar: {FR: 'VE ou Borne de recharge', EN: 'EV or EVSE'},

      textSharingTransmitted: {FR: 'La modification a été enregistrée avec succès!', EN: 'modification was successfully saved!'},
      textSharingTransmitted2: {FR: 'Vous pouvez fermer cette fenêtre.', EN: 'You can close this window.'},

      labelButtonShare: {FR: "Enregistrer les modifications", EN: 'Save modifications'},
    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','actualGroup']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  methods: {

    loadRuleTemplate() {
        var requestData = { 'postAction':'GetSingleRulePermissions',
                            'ruleId': this.overlayParameters.ruleId,
                            'referenceId': this.overlayParameters.referenceId,
                            }
        this.$store.dispatch('sessionStore/postRule', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                console.log(response.data)
                this.ruleTemplate = response.data.Data
                this.sharingEntityType = response.data.Data.entityType

                if(this.sharingEntityType=='Car'){
                  this.displayCarOptions = true 
                }

                if(this.sharingEntityType=='Channel'){
                  this.displayChannelOptions = true 
                }

                if(this.sharingEntityType=='Device'){
                  this.displayDeviceOptions = true 
                }

                if(this.sharingEntityType=='Bundle'){
                  this.displayDeviceOptions = true
                  this.displayChannelOptions = true
                  this.displayBundleOptions = true
                  this.displayAlertOptions = true  
                }

                if(this.sharingEntityType=='Group'){
                  this.displayDeviceOptions = true
                  this.displayChannelOptions = true
                  this.displayBundleOptions = true
                  this.displayGroupOptions = true
                  this.displayAlertOptions = true 
                }

                this.flagRuleIsLoading = false
                }
                else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
            })
    },

    toUsername(email) {
      var email2 = email.replace('.', '-dot-')
      email = email2.replace('.', '-dot-')
      email2 = email.replace('.', '-dot-')
      return email2.replace('@', '-at-')
    },

    saveSharingPermissions() {
        this.commentIsSaving = true
        var requestData = { 'postAction':'SaveSingleRulePermissions',
                            'ruleId': this.overlayParameters.ruleId,
                            'referenceId': this.overlayParameters.referenceId,
                            'permissions': this.ruleTemplate.permissions,
                            }
        console.log(requestData)

        this.$store.dispatch('sessionStore/postRule', requestData)
            .then((response) => {
              //console.log(response.data)
              this.commentIsSaving = false
            if(response.data.Code=='OK'){
                this.sharingTransmittedFlag = true
                }
                else{ 
                  window.alert(response.data.Message[this.actualLanguage])}
            })       
      
    },
  },


  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //this.channelIndex = localStorage.actualChannelIndex
    this.channelIndex = this.overlayParameters.channelIndex

    this.loadRuleTemplate()

  }


}
</script>



// WEBPACK FOOTER //
// EditAccessRulesForm.vue?09ac354d